module.exports = __webpack_public_path__ + "img/PERISCOLAIRE.2a289893.svg";